import { useEffect, useRef } from 'react';

type IntervalFunction = () => unknown | void;

/**
 * @see https://overreacted.io/making-setinterval-declarative-with-react-hooks/
 */
export default function useInterval(callback: IntervalFunction, delay: number, immediate = false) {
  const savedCallback = useRef<IntervalFunction | null>();

  // Save the latest callback to be referenced in setInterval
  // Otherwise, we won't have access to the latest callback that includes fresh props and state
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  // eslint-disable-next-line consistent-return
  useEffect(() => {
    function tick() {
      if (typeof savedCallback.current === 'function') {
        savedCallback.current();
      }
    }

    if (delay !== null) {
      if (immediate) {
        tick();
      }

      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay, immediate]);
}
